// extracted by mini-css-extract-plugin
export var downArrow = "_ao-0";
export var label = "_ao-1";
export var treatmentCard = "_ao-3";
export var upArrow = "_ao-2";